import React from 'react';
import { useFirstImpressionsState } from '../use-first-impressions-state';
import {
  FirstImpressionsLoadingView,
  FirstImpressionsLoggedOutView
} from './views';

export function FirstImpressionsFormView() {
  const firstImpressionState = useFirstImpressionsState();

  switch (firstImpressionState.activeFormView) {
    case 'first-impressions-loading':
      return <FirstImpressionsLoadingView />;
    case 'first-impressions-logged-out':
      return <FirstImpressionsLoggedOutView />;
    default:
      return <FirstImpressionsLoadingView />;
  }
}
